export default __webpack_public_path__ + "da7c40b.png";